export const faqs = [
  {
    question: '爆料网上是什么？它自己接收爆料吗？',
    answer:
      '爆料网上是一个导航门户，本身不直接受理线索。我们做的是把分散在各地的爆料网站、论坛与社区按类别整理成清晰目录，并配套整理投稿指南，帮你更快找到匹配的渠道。',
  },
  {
    question: '这些平台和论坛是免费使用的吗？',
    answer:
      '目录中收录的绝大多数入口都可以免费浏览和发布。如果遇到要求你先付费、缴纳保证金或购买课程才能"帮忙跟进"的渠道，请提高警惕，通常这不是正规做法。',
  },
  {
    question: '我完全不懂流程，应该从哪一步开始？',
    answer:
      '建议先看发布指南里的"如何安全且有效地提交一条线索"，把时间线和材料整理清楚，再到平台导航大全里按分类选择两到三个匹配渠道投递即可。',
  },
  {
    question: '投递之后大概多久会有回应？',
    answer:
      '不同渠道差异较大，综合类入口通常几天到两周不等，垂直类渠道相对快一些。建议记录投递时间，间隔一周左右做一次礼貌的进度询问，避免反复刷屏。',
  },
  {
    question: '提交线索时会不会暴露我的真实身份？',
    answer:
      '是否暴露取决于你使用的账号和提交的材料。建议使用与日常生活无关的独立账号，对截图中的头像、昵称、手机号等做遮盖处理，并在提交时明确说明希望隐去的信息。',
  },
  {
    question: '目录里的平台失效或改版了怎么办？',
    answer:
      '我们会在每个平台卡片上标注最近核验日期。若你发现某个入口无法访问或内容方向发生变化，可以通过联系我们页面提交反馈，我们会在核实后更新或下架该条目。',
  },
  {
    question: '为什么有的平台标注了"已核验"？',
    answer:
      '标注"已核验"表示该入口在最近一次检查中可以正常访问，且具备清晰的发布规则或材料要求。未标注并不代表有问题，只是我们尚未完成最新一轮核验。',
  },
  {
    question: '可以把一条线索同时投给多个渠道吗？',
    answer:
      '可以，但不建议群发到十几个渠道。选择两到三个匹配度最高的入口，并根据各渠道的读者特点略微调整表述，效果通常比单纯复制粘贴好得多。',
  },
];